
import React from 'react';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import { useArtistData } from '@/hooks/useArtistData';
import LoadingIndicator from '@/components/shared/LoadingIndicator';
import TracksContent from '@/components/tracks/TracksContent';
import { useAuthCheck } from '@/components/tracks/useAuthCheck';
import { useCreationState } from '@/components/tracks/useCreationState';

const TracksPage: React.FC = () => {
  const { uploads, isLoading: uploadsLoading, artistId, addUpload, removeUpload } = useArtistData();
  const { isLoading: authLoading } = useAuthCheck();
  const { isCreating, handleCreateClick, handleCreateSuccess } = useCreationState();

  // Show loading indicator while checking auth or loading uploads
  if (authLoading || uploadsLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow pt-24 pb-20">
        <TracksContent 
          isCreating={isCreating}
          uploads={uploads}
          artistId={artistId}
          handleCreateClick={handleCreateClick}
          handleCreateSuccess={handleCreateSuccess}
          addUpload={addUpload}
          removeUpload={removeUpload}
        />
      </main>
      
      <Footer />
    </div>
  );
};

export default TracksPage;
